// =============================================================================
// CARD SECTION COMPONENT
// =============================================================================

import React from 'react';
import { Card } from '@/components/Card';
import { Button } from '@/components/Button';
import { createActionHandler, convertButtonToAction } from '@/utils/actionHandler';
import type { ContentComponent } from '@/types';

interface CardSectionProps {
  component: ContentComponent;
}

/**
 * Card Section Component
 */
export const CardSection: React.FC<CardSectionProps> = ({ component }) => {
  return <CardSectionImpl component={component} />;
};

/**
 * Card Section Implementation
 */
const CardSectionImpl: React.FC<{ component: ContentComponent }> = ({ component }) => {
  const { id, title, content, metadata } = component;
  
  const cards = metadata?.cards || [];
  const columns = metadata?.columns || 3;
  
  return (
    <section id={id} className="content-section card-section">
      <div className="container">
        {title && (
          <div className="section-header">
            <h2>{title}</h2>
            {content && <p>{content}</p>}
          </div>
        )}
        
        <div className={`grid grid-cols-${columns}`}>
          {cards.map((card: any, index: number) => {
            // Convert old button format to actions
            const actions = card.button 
              ? [convertButtonToAction(card.button)]
              : card.buttons?.map(convertButtonToAction) || [];
            
            return (
              <Card
                key={index}
                title={card.title}
                subtitle={card.subtitle}
                image={card.image}
                imageCredit={card.imageCredit}
                actions={
                  actions.length > 0 ? (
                    <div className="card-actions">
                      {actions.map((action: any, actionIndex: number) => (
                        <Button
                          key={actionIndex}
                          variant={action.variant || 'primary'}
                          onClick={createActionHandler(action)}
                        >
                          {action.label}
                        </Button>
                      ))}
                    </div>
                  ) : undefined
                }
              >
                {card.content && (
                  <div dangerouslySetInnerHTML={{ __html: card.content }} />
                )}
                
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export { CardSectionImpl };

